module.exports = __webpack_public_path__ + "img/new-data.e68da165.png";